import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Loader from '../../../../loader/loader';
import ReactTable from "react-table";
import 'react-table/react-table.css';
import swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Pagination from '../../../../pagination/pagination';

export default class PayScaleResults extends Component {

    componentWillMount() {
        this.props.fetchPayScales();
    }

    handleDelete = (id) => {
        swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if(result.value)
            {
                this.props.removePayScale(id);
            }
          })
    }

    handleEdit = (id) => {
        this.props.onOpenEditModal(id);
    }

    render () {
        const data = this.props.payscales;
        const columns = [{
            Header: 'Name',
            accessor: 'name' // String-based value accessors!
          }, {
            Header: 'Actions',
            Cell: row => (
                <div className="actions">
                    <ul className="list-inline">
                        <li><button className="link" onClick={() => this.handleEdit(row.original.id)}>Edit</button></li>
                        <li><span className="seprator">|</span></li>
                        <li><button className="link" onClick={() => this.handleDelete(row.original.id)}>Delete</button></li>
                    </ul>
                </div>
            )
         }];

        return (
            <div className="table-area">
                {this.props.loading && <Loader />}
                <ReactTable
                    PaginationComponent={Pagination}
                    data={data}
                    columns={columns}
                    noDataText="No PayScales Found."
                    defaultPageSize={10}
                    resizable={true}
                    minRows={5}
                />
            </div>
        );
    }

}

PayScaleResults.propTypes = {
    payscales: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
        }).isRequired
    ),
    fetchPayScales: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    removePayScale: PropTypes.func.isRequired,

}
